import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";

// reactstrap components
import {
    Row,
    Col,
    Container,
    Card, CardBody
} from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET, api_POST } from "../../../services/api_service.js";

// views
import ListaVeiculosExclusao from "../../../views/Shared/Transportador/ListaVeiculosExclusao";
import Documentos from "../../../views/Shared/Documentos";

//Context
import { useAuth } from '../../../context/auth';
import RequerimentoAvisoCard from '../components/RequerimentoAvisoCard';

export default function TransportadorRequerimentoExclusaoVeiculo({ history }) {
    const { session, setLoading, setupSistema } = useAuth();

    const location = useLocation();

    const [requerimento, set_requerimento] = React.useState(null);
    const [protocolo, set_protocolo] = React.useState(null);
    const opcao = {
        tipoCadastro: "Requerimento",
        segmento: "Transportador",
        categoria: "RCC"
    }

    const [steps, set_steps] = React.useState([]);
    const loadSteps = () => {
        api_GET('setupSolicitacao/GetByAcaoId/' + location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id)
            .then(result => {
                if (result.data.solicitacaoAcoes.filter(f => f.setupSolicitacaoAcao_Id == location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id)[0].acaoDocumentos.length > 0)
                    set_steps(["Veículos", "Documentos"]);
                else
                    set_steps(["Veículos"]);
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const [step, set_step] = React.useState(0);
    const handleProximoStep = (_requerimento) => {
        if (step == 2) {

        }
        else {
            set_requerimento(_requerimento);
            set_step(step + 1);
        }
    }
    const handleStepAnterior = (_requerimento) => {
        set_requerimento(_requerimento)
        set_step(step - 1);
    }

    const loadRequerimento = () => {
        if (location.state.requerimento == null) {
            setLoading(true);
            let json_submit = {
                protocolo_Id: location.state.protocolo.protocolo_Id,
                requerimento_Id: 0,
                nomeSolicitante: location.state.protocolo.nomeSolicitante,
                email: location.state.protocolo.email,
                cpf_Cnpj: location.state.protocolo.cpf_Cnpj,
                setupSolicitacaoAcao_Id: location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id,
            }

            api_POST('requerimento/PostRequerimento ', json_submit)
                .then(result => {
                    set_requerimento(result.data);
                    loadProtocolo(result.data.protocolo_Id);
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
        else {
            api_GET('requerimento/' + location.state.requerimento.requerimento_Id)
                .then(result => {
                    set_requerimento(result.data);
                    loadProtocolo(result.data.protocolo_Id);
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }

    const loadProtocolo = (protocolo_Id) => {
        api_GET('ProtocoloTransportador/' + protocolo_Id)
            .then(result => set_protocolo(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleFinalizarRequerimento = () => {
        setLoading(true);
        api_POST('requerimento/PostFinalizarSolicitacaoRequerimento', requerimento)
            .then(result => { showMessage("Aviso", "Solicitação enviada com sucesso. Acompanhe o andamento através do seu cadastro! ", 'success', function () { history.push("/auth/meucadastro") }) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadSteps();
        loadRequerimento();
    }, []);

    return (
        <>
            {requerimento != null && (requerimento.status == "Em Andamento" || requerimento.status == "Divergente") &&
                <div className="content">
                    <Container className="text-center">
                        <ProgressBar stepValue={step} steps={steps} />
                    </Container>
                    {requerimento.status == "Divergente" && requerimento.requerimentoAnaliseGestor.length > 0 &&
                        <Card className="card-stats">
                            <CardBody>
                                <h5 className={`${session && session.tipoAcesso == "AreaRestrita" ? "text-white" : "text-black"}`}>Seu requerimento foi rejeitado por {setupSistema?.identificacao}. Verifique as informações abaixo e corrija os dados necessários.</h5>
                                <p>{requerimento.requerimentoAnaliseGestor.sort(function (a, b) { return new Date(b.dataAnalise) - new Date(a.dataAnalise); })[0].observacao}</p>
                            </CardBody>
                        </Card>
                    }
                    {step == 0 &&
                        <>
                            <RequerimentoAvisoCard />
                            <ListaVeiculosExclusao
                                item={requerimento}
                                protocolo={protocolo}
                                handleProximoStep={steps.length > 1 ? handleProximoStep : handleFinalizarRequerimento}
                            />
                        </>
                    }
                    {step == 1 &&
                        <Documentos
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleFinalizarRequerimento}
                            handleStepAnterior={handleStepAnterior}
                        />
                    }
                </div>
            }
            {requerimento != null && (requerimento.status != "Em Andamento" && requerimento.status != "Divergente") &&
                <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                    <div className="formPrincipal">
                        <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, .5)", paddingBottom: "10px", paddingTop: "10px" }}>
                            <Col md="12">
                                <span className={`${session && session.tipoAcesso == "AreaRestrita" ? "text-white" : "text-black"}`}>Este requerimento já foi finalizado. Para visualizar e acompanhar as informações do requerimento, acesse o menu "Meu Cadastro".</span>
                            </Col>
                        </Row>
                    </div>
                </Container>
            }
        </>
    );
}